import { createElement } from 'react';
import './index.scss';
const justify = {
    '1': 'center',
    '2': 'flex-start',
    '3': 'flex-end',
    '4': 'space-between',
    '5': 'space-end'
};
const updownlayout = (props) => {
    const { justifyContent, ...others } = props;
    return (createElement("div", Object.assign({ className: "updownlayout" }, others, { style: { justifyContent: justify[justifyContent] } }), props.children));
};
export default updownlayout;
